document.addEventListener('DOMContentLoaded', function () {
  const PRINT_FEE_HANDLES = {
  one: 'one-colour-printing-fee',
  two: 'two-colour-printing-fee'
};

const SETUP_FEE_HANDLES = {
  one: 'one-colour-setup-fee',
  two: 'two-colour-setup-fee'
};

  const feeCache = {};

  function normalizeLogoType(value) {
    value = (value || '').toLowerCase();

    if (value.includes('one')) return 'one';
    if (value.includes('two') || value.includes('multi')) return 'two';

    return null;
  }

  function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || 'USD';

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(cents / 100);
}

function getPrintMultiplier(location) {
  const productsInSetInput =
    document.getElementById('ProductsInSet') ||
    document.querySelector('input[name="products-in-set"]');

  const printableBoxesInput =
    document.querySelector('input[name="printable-boxes"]');

  const productsInSet = Math.max(
    1,
    parseInt(productsInSetInput?.value || '1', 10)
  );

  const printableBoxes = Math.max(
    1,
    parseInt(printableBoxesInput?.value || '1', 10)
  );

  if (location === 'Product + Box') {
    return productsInSet + printableBoxes;
  }

  if (location === 'Product Only') {
    return productsInSet;
  }

  if (location === 'Box Only') {
    return printableBoxes;
  }

  return 1;
}

  async function getProductByHandle(handle) {
    if (feeCache[handle]) return feeCache[handle];

    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) {
      throw new Error(`Could not load product: ${handle}`);
    }

    const product = await response.json();
    feeCache[handle] = product;

    return product;
  }

  async function updatePrintPrices(logoTypeKey) {
    const cards = document.querySelectorAll('.client-print-location-card');

    for (const card of cards) {
      const location = card.dataset.printLocation;
      const handle = PRINT_FEE_HANDLES[logoTypeKey];
      const multiplier = getPrintMultiplier(location);
      const priceEl = card.querySelector('.print-location-price');

      if (!handle || !priceEl) continue;

      try {
        const product = await getProductByHandle(handle);
        const variant = product.variants[0];

        priceEl.textContent = '+' + formatMoney(variant.price * multiplier);
      } catch (error) {
        console.error(error);
        priceEl.textContent = 'Unavailable';
      }
    }
  }

  document.addEventListener('change', async function (event) {
    if (event.target.matches('input[name="properties[Private Label]"]')) {
      const fields = document.querySelector('.private-label-fields');

      if (fields) {
        fields.hidden = event.target.value !== 'Yes';
      }
    }

    if (event.target.matches('input[name="properties[Logo Name]"]')) {
      const logoType = event.target.dataset.logoType || '';
      const logoTypeKey = normalizeLogoType(logoType);

      const printTypeInput = document.getElementById('SelectedLogoPrintType');
      if (printTypeInput) {
        printTypeInput.value = logoType;
      }

      if (logoTypeKey) {
        await updatePrintPrices(logoTypeKey);
      }
    }
  });

  document.addEventListener('click', function (event) {
    const card = event.target.closest('.client-print-location-card');
    if (!card) return;

    document.querySelectorAll('.client-print-location-card').forEach(function (item) {
      item.classList.remove('active');
    });

    card.classList.add('active');

    const hiddenLocation = document.getElementById('SelectedPrintLocation');
    if (hiddenLocation) {
      hiddenLocation.value = card.dataset.printLocation;
    }
  });
    window.addPrivateLabelFeesToCart = async function(form) {
    const formId = form.getAttribute('id');

    const privateLabel =
      document.querySelector(`input[name="properties[Private Label]"][form="${formId}"]:checked`)?.value || 'No';

    if (privateLabel !== 'Yes') return true;

    const selectedLogo =
      document.querySelector(`input[name="properties[Logo Name]"][form="${formId}"]:checked`);

    const printLocation = document.getElementById('SelectedPrintLocation')?.value || '';

    if (!selectedLogo) {
      alert('Please choose a logo.');
      return false;
    }

    if (!printLocation) {
      alert('Please choose a print location.');
      return false;
    }

    const quantityInput =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('quantity-input input[name="quantity"]') ||
      document.querySelector('input.quantity__input');

    const quantity = Number(quantityInput?.value || 1);
    const logoTypeKey = normalizeLogoType(selectedLogo.dataset.logoType);

    const printHandle = PRINT_FEE_HANDLES[logoTypeKey][printLocation];
    const setupHandle = logoTypeKey === 'one' ? 'one-colour-setup-fee' : 'two-colour-setup-fee';

    const printProduct = await getProductByHandle(printHandle);
    const printVariant = printProduct.variants[0];

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const setupAlreadyExists = cart.items.some(function(item) {
      return item.handle === setupHandle;
    });

    const items = [
      {
        id: printVariant.id,
        quantity: quantity,
        properties: {
          'Logo Colors': selectedLogo.dataset.logoType || '',
          'Print Location': printLocation
        }
      }
    ];

    if (!setupAlreadyExists) {
      const setupProduct = await getProductByHandle(setupHandle);
      const setupVariant = setupProduct.variants[0];

      items.push({
        id: setupVariant.id,
        quantity: 1
      });
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    return true;
  };
    window.addPrivateLabelFeesToCart = async function(form) {
    const formId = form.getAttribute('id');

    const privateLabel =
      document.querySelector(`input[name="properties[Private Label]"]:checked`)?.value || 'No';
    
    if (privateLabel !== 'Yes') return true;

    const selectedLogo =
      document.querySelector(`input[name="properties[Logo Name]"]:checked`);

    const printLocation = document.getElementById('SelectedPrintLocation')?.value || '';

    if (!selectedLogo) {
      alert('Please choose a logo.');
      return false;
    }

    if (!printLocation) {
      alert('Please choose a print location.');
      return false;
    }

    const quantityInput =
      form.querySelector('[name="quantity"]') ||
      document.querySelector('quantity-input input[name="quantity"]') ||
      document.querySelector('input.quantity__input');

    const productQty = Number(quantityInput?.value || 1);
    const printQty = productQty * getPrintMultiplier(printLocation);

    const logoTypeKey = normalizeLogoType(selectedLogo.dataset.logoType);

    const printHandle = PRINT_FEE_HANDLES[logoTypeKey];
    const setupHandle = SETUP_FEE_HANDLES[logoTypeKey];

    const printProduct = await getProductByHandle(printHandle);
    const printVariant = printProduct.variants[0];

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const setupAlreadyExists = cart.items.some(function(item) {
      return item.handle === setupHandle;
    });

    const items = [
      {
        id: printVariant.id,
        quantity: printQty
      }
    ];

    if (!setupAlreadyExists) {
      const setupProduct = await getProductByHandle(setupHandle);
      const setupVariant = setupProduct.variants[0];

      items.push({
        id: setupVariant.id,
        quantity: 1
      });
    }

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });

    return true;
  };
   
  window.syncPrivateLabelCartOld = async function () {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const requiredPrintUnits = {
      one: 0,
      two: 0
    };

    cart.items.forEach((item) => {
      console.log('REQUIRED PRINT TOTALS', requiredPrintUnits);
      const properties = item.properties || {};
      const printUnits = Number(properties['_Print Units'] || 0);

      if (printUnits <= 0) return;

      const logoPrinting =
        properties['Logo Printing'] ||
        properties['Logo Colors'] ||
        '';

      const logoTypeKey = normalizeLogoType(logoPrinting);

      if (!Object.prototype.hasOwnProperty.call(requiredPrintUnits, logoTypeKey)) {
        return;
      }

      requiredPrintUnits[logoTypeKey] += printUnits * item.quantity;
      console.log('PRINT ITEM', {
  title: item.product_title,
  quantity: item.quantity,
  printUnits: printUnits,
  logoPrinting: logoPrinting,
  logoTypeKey: logoTypeKey,
  lineTotal: printUnits * item.quantity
});
    });

    const updates = {};
let cartChanged = false;

for (const logoTypeKey of ['one', 'two']) {
  const printHandle = PRINT_FEE_HANDLES[logoTypeKey];

  if (!printHandle) continue;

  const printProduct = await getProductByHandle(printHandle);
  const printVariant = printProduct?.variants?.[0];

  if (!printVariant) continue;

  const requiredQuantity = requiredPrintUnits[logoTypeKey];

  const existingFeeItems = cart.items.filter(
    (item) => Number(item.variant_id) === Number(printVariant.id)
  );

  if (existingFeeItems.length === 0) {
    continue;
  }

  existingFeeItems.forEach((feeItem, index) => {
    const desiredQuantity = index === 0 ? requiredQuantity : 0;

    if (feeItem.quantity !== desiredQuantity) {
      updates[feeItem.key] = desiredQuantity;
      cartChanged = true;
    }
  });
}

if (!cartChanged) {
  return false;
}

const updateResponse = await fetch('/cart/update.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    updates: updates
  })
});

    if (!updateResponse.ok) {
      throw new Error('Unable to update private-label printing fees.');
    }

    return true;
  } catch (error) {
    console.error('Private-label cart synchronization error:', error);
    return false;
  }
};

})();